// src/components/Giles.js
import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';

/* -------------------
   Global styles & fonts
------------------- */
const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: 'AnybodyMedium';
    src: url('../assets/fonts/Anybody-Medium.ttf') format('truetype');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'LexendMega';
    src: url('../assets/fonts/LexendMega-Regular.ttf') format('truetype');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }
  *, *::before, *::after { box-sizing: border-box; }
  body { margin: 0; background:#fff; font-family:'AnybodyMedium','Anybody',sans-serif; color:#000; }
`;

/* -------------------
   Layout helpers
------------------- */
const Page = styled.article`
  max-width: 110rem; /* 1440px */
  margin: 0 auto;
  overflow-x: hidden;
`;

/* Центрированные media (общие) */
const CenterImg = styled.img`
  width: 100%;
  max-width: 40rem; /* 1120px */
  height: auto;
  display: block;
  margin: 0 auto;
`;

/* Центрированные media (общие) */
const HeaderImg = styled.img`
  width: 100%;
  max-width: 80rem; /* 1120px */
  height: auto;
  display: block;
  margin: 0 auto;
`;
const CenterVideo = styled.video`
  width: 100%;
  max-width: 38rem; /* 1120px */
  height: auto;
  display: block;
  margin: 0 auto;
`;

/* Портретное видео/изображение */
const TallMedia = styled.video`
  width: 100%;
  max-width: 37.5rem; /* 600px */
  height: auto;
  display: block;
  margin: 0 auto;
`;

/* -------------------
   Текстовые стили
------------------- */
const Meta = styled.p`
  font-style: italic;
  font-weight: 300;
  font-size: clamp(1rem, 1.4vw, 1.25rem);
  text-align: center;
  margin: 1rem 0 2rem;
`;

const Heading = styled.h2`
  font-weight: 700;
  font-size: clamp(1rem, 1.6vw, 1.5625rem);
  text-align: center;
  margin: 2rem auto;
  max-width: 60.7rem;
`;

const QA = styled.div`
  max-width: 82.25rem;
  margin: 2.5rem auto;
  font-size: clamp(1.25rem, 1.8vw, 1.5625rem);
  line-height: 1.42;
  text-align: center;

  strong { font-weight: 600; }
  em { font-style: italic; }
`;

/* -------------------
   Spotify + image side‑by‑side
------------------- */

const FinalRow   = styled.div`display:flex; flex-wrap:wrap; gap:2rem; justify-content:center; margin:3rem 0;`;

const SideColumn = styled.div`display:flex; flex-direction:column; align-items:center; flex:1 1 20rem; max-width:30rem;`;
const SideImg = styled.img`
  width: 100%;
  max-width: 30rem; /* 400px */
  height: 42rem; /* match Spotify */
  object-fit: cover;
  flex: 1 1 20rem;
`;
const SpotifyFrame = styled.iframe`
  display:block; width:100%; max-width:25rem; height:42rem;
  border-radius:0.75rem; border:none; flex:1 1 20rem;
`;
/* -------------------
   Footer
------------------- */
const FooterBar = styled.footer`
background: #000;
padding: clamp(3rem, 1vh, 3rem) 0;
text-align: center;

h1 {
  font-family: 'AnybodyBlack', 'Anybody', sans-serif;
  color: #fff;
  font-size: clamp(2.6rem, 8vw, 8rem);
  font-weight: 900;
  margin: 0;
  line-height: 1;
}
`;

/* ===============================================================
   Component
================================================================ */
export default function Giles() {
  return (
    <Page>
      <GlobalStyles />

      {/* Header image */}
      <HeaderImg src="/assets/gilesheader1.png" alt="Giles header" />

      <Heading>
      GABRIEL MEALOR-PRITCHARD ASKS FASHION DESIGNER EXTRAORDINAIRE GILES DEACON THE BURNING QUESTIONS WE JUST HAVE TO KNOW THE ANSWERS TO!
      </Heading>
      <br />

      {/* Q&A block 1 */}
      <QA>
        <strong>You created the iconic blue dress, in collaboration with Tiffany, that Beyoncé wore during the Chicago leg of her Renaissance Tour. What's your favourite Beyoncé song?</strong><br /><br />
        "Crazy In Love - Loved the video and it landed like a bolt in the summer of 2004 - people played it everywhere!"
      </QA>

      {/* Hero video */}
      <CenterVideo src="/assets/giles1.mp4" autoPlay loop muted playsInline />
      <Meta>© Beyoncé's Instagram – @beyonce</Meta>

      <QA>
        <strong>Can you describe in three words how growing up in Darlington/The Lake District shaped your view on the world of fashion?</strong><br /><br />
        "Mood - Melancholy - Method"<br /><br />
        <strong>Favourite night out ever. Who were you with? What went on?</strong><br /><br />
        "Summer 1997 in NYC with the Wu-Tang Clan - can't say anymore..."
      </QA>

      {/* Cover image */}
      <CenterImg src="/assets/gilesmain.png" alt="GILESSØLVEKATIE cover" />
      <Meta>GILESSØLVEKATIE — 25 Jun 2018</Meta>

      <QA>
        <strong>If you had to choose one image from GILESSØLVEKATIE that you feel best represents the alchemy between your designs, Katie’s styling, and Sølve’s lens, which would it be, and why?</strong><br /><br />
        "Has to be the cover - clue is in the title..."<br /><br />
        <strong>Illegal raves up north - condensed into just one sentence?</strong><br /><br />
        "Fields far, far away - the smaller and more rural the better."<br /><br />
        <strong>Your muse, your wife, Gwendoline. If you had to choose a favourite garment you have created for her, which would it be?</strong><br /><br />
        "Always the next one!"<br /><br />
        <em>(Below, Gwendoline at the BAFTAs 2025 in custom Giles Deacon, The Amphitrite Gown) Photography by @akehurstjohn</em>
      </QA>

      {/* Portrait video */}
      <TallMedia as="video" src="/assets/giles2.mp4" autoPlay loop muted playsInline />
      <Meta>© Giles Deacon's Instagram – @gilesdeacon_</Meta>
      <QA>
        <strong>Steve Mackey created soundscapes for your fashion shows. How was it to work with him?</strong><br /><br />
        "Memories every day - His laugh"<br /><br />
        <strong>Which collaboration of yours totally caught you off guard?</strong><br /><br />
        "The Gwendoline Star Wars dress - doesn't happen every day..."<br /><br />
        <strong>
        What are your five forever tracks? The ones you return to again and again in the studio, on the dancefloor, or in your head when dreaming up something new?</strong><br /><br />
        "I am more desert‑island albums..."<br /><br />
        KLF - Chill Out / Aphex Twin - Selected Ambient Works / Dead Can Dance - The Serpent's Egg / Michael Nyman - The Draughtsman's Contract / This Mortal Coil - Filigree and Shadow
      </QA>

      <br />
      <br />
      {/* Summary paragraphs */}
      <QA as="p">Within this spirited exchange, fashion visionary Giles Deacon opens up with refreshing candour. From his favourite songs/albums to raucous summer nights with the Wu-Tang Clan, Deacon dances between the sublime and the surreal, all while shedding light on a life lived upon the intersection of high-fashion and ambient sound.</QA>
      <QA as="p">Speaking poignantly of his late collaborator, Steve Mackey, and offering insight into his personal relationship that fuels his designs, particularly highlighting his muse, Gwendoline Christie, to whom he devotes tonnes of his creativity. In addition, whether he is reminiscing about those secret illegal raves in the north of England he used to frequent or reflecting on his fashion legacy captured within the pages of GILESSØLVEKATIE, Deacon remains both elusive yet always evocative.</QA>
      <QA as="p">The choice of his desert island albums illustrate that he resists the traditional favourites. Instead,  offering us a soundtrack composed of atmospheric and electronic tones, unveiling to us his favour for ambient noise. Aphex Twin's 1992 album is a fine choice with its ethereal textures and defined sense of edge, paired seamlessly with the melancholic resonance of This Mortal Coil's Filigree and Shadow, which allows the connection between these two selections to fit oh so naturally.</QA>
      <QA as="p">This quickfire Q&A reads like a mixtape of cultural moments and heartfelt reflections of a life of spontaneity and acts as a rare insight into the world of one of fashion's most enigmatic minds, Giles Deacon.</QA>
      <br />
      <br />
      <br />
      <br />
      {/* Playlist heading */}
      <Heading>FROM HIS ASTOUND SELECTIONS, GILES DEACON CURATES A UNIQUE PLAYLIST FOR RIFF MAGAZINE, LISTEN TO IT BELOW!</Heading>
      <br />
      <br />
      <br />
      <br />
      {/* Side‑by‑side image + Spotify */}
      {/* Side-by-side: image + Spotify with credit under image */}
      <FinalRow>
        <SideColumn>
          <SideImg src="/assets/giles2.png" alt="Giles portrait" />
          <Meta as="p">PHOTOGRAPHED BY GAULTIER DEBLONDE</Meta>
        </SideColumn>

        <SpotifyFrame
          src="https://open.spotify.com/embed/playlist/0N1X3JThFcIRn6dBt6OX8A?utm_source=generator"
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
          loading="lazy"
          title="Giles playlist"
        />
      </FinalRow>

      <FooterBar>
        <h1>RIFF MAGAZINE</h1>
      </FooterBar>
    </Page>
  );
}
